module.exports = __webpack_public_path__ + "static/media/8. Transparencia azul1, Resina epóxica y óleo, 95 x 225 cm, 2019 copy.eb017cbb.png";